module.exports = "<app-cabecera-formulario [dDatosCompartidosCabecera] = \"dDatosCompartidosCabecera\"></app-cabecera-formulario>\r\n<div class=\"container-cards\" style=\"background-color: #eeeeee;min-height: 400px;\">\r\n\t<app-formulario [dDatosCompartidosCabecera] = \"dDatosCompartidosCabecera\"></app-formulario>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.html
// module id = ../../../../../src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.html
// module chunks = main